// extracted by mini-css-extract-plugin
export var avatar = "_oz-3";
export var avatarContainer = "_oz-2";
export var avatarSpacer = "_oz-5";
export var avatarSpacerContainer = "_oz-4";
export var avatarStackContainer = "_oz-1";
export var bubble = "_oz-0";
export var remainderBubble = "_oz-6";